import axios from 'axios';

const publicApi = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_API_URL,
});

publicApi.interceptors.response.use(
  (response) => Promise.resolve(response),
  async (error) => {
    if (error.config && error.response) {
      if (error.response.status >= 500) {
        // TODO: Exibir erros de forma amigável
        // eslint-disable-next-line no-alert
        alert(
          'Houve um problema ao realizar a sua requisição e já estamos resolvendo. Por favor, tente novamente mais tarde.'
        );
      } else if (error.response.status === 0) {
        // TODO: Exibir erros de forma amigável
        // eslint-disable-next-line no-alert
        alert(
          'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente'
        );
      }
    }

    return Promise.reject(error);
  }
);

export default {
  get: publicApi.get.bind(publicApi),
  post: publicApi.post.bind(publicApi),
};
